<!-- Единая секция действий на главной странице. -->
<template>
  <section class="home-section">
    <div class="home-section__header">
      <p class="home-section__label">{{ title }}</p>
      <slot name="actions" />
    </div>

    <div class="home-section__content">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeSection",

  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.home-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.home-section__header {
  display: flex;
  align-items: center;
  gap: 6px;
}

.home-section__label {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  color: #999;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.home-section__content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

@media (max-width: 600px) {
  .home-section {
    width: 100%;
  }
}
</style>
